import type { Hero } from '../types';

function stripMarks(value: string): string {
  return value.normalize('NFKD').replace(/\p{M}/gu, '');
}

export function normalizeSearchTerm(value: string): string {
  return stripMarks(value)
    .toLocaleLowerCase('en-US')
    .replace(/[^\p{L}\p{N}]+/gu, '');
}

export function createEnglishInitialism(name: string): string {
  const words = stripMarks(name.replace(/['’]/g, '')).match(/[\p{L}\p{N}]+/gu) ?? [];
  return words.map((word) => word[0]).join('').toLocaleLowerCase('en-US');
}

export function heroSearchScore(hero: Hero, query: string): number | null {
  const needle = normalizeSearchTerm(query);
  if (!needle) return 0;

  const nameZh = normalizeSearchTerm(hero.nameZh);
  const nameEn = normalizeSearchTerm(hero.nameEn);
  const slug = normalizeSearchTerm(hero.slug);
  const initialism = createEnglishInitialism(hero.nameEn);

  if (initialism === needle) return 120;
  if (nameZh === needle || nameEn === needle) return 115;
  if (nameZh.startsWith(needle) || nameEn.startsWith(needle)) return 100;
  if (initialism.startsWith(needle)) return 90;
  if (nameZh.includes(needle) || nameEn.includes(needle)) return 80;
  if (slug.startsWith(needle)) return 60;
  if (slug.includes(needle)) return 50;
  return null;
}

export function rankHeroesByQuery(heroes: Hero[], query: string): Hero[] {
  if (!normalizeSearchTerm(query)) return heroes;
  return heroes
    .map((hero, index) => ({ hero, index, score: heroSearchScore(hero, query) }))
    .filter((item): item is typeof item & { score: number } => item.score !== null)
    .sort((a, b) => b.score - a.score || a.index - b.index)
    .map((item) => item.hero);
}
